<div class="bg-cm-blue-50 dark:bg-cm-blue-800 p-6 rounded-lg space-y-4">
  <!-- Title -->
  <h3 class="h3 font-bold text-cm-blue-900 dark:text-cm-grey-50">
    {{ 'otc-desk.fees.header.title' | translate }}
  </h3>

  <!-- Table -->
  <div class="grid w-full grid-cols-3 gap-y-2">
    <div class="contents">
      <div class="font-bold pl-3">{{ 'otc-desk.fees.header.transactionVolume' | translate }}</div>
      <div class="font-bold">{{ 'otc-desk.fees.header.czk' | translate }}</div>
      <div class="font-bold">{{ 'otc-desk.fees.header.eur' | translate }}</div>
    </div>

    <ng-container *ngFor="let fee of feeOptions">
      <div class="contents">
        <div class="bg-cm-blue-100 dark:bg-cm-blue-900 rounded-l pl-3 py-2 items-center">
          {{ fee.rangeKey | translate }}
        </div>
        <div class="bg-cm-blue-100 dark:bg-cm-blue-900 px-1 py-2 items-center">
          {{ fee.czk | appPercentage | async }}
        </div>
        <div class="bg-cm-blue-100 dark:bg-cm-blue-900 rounded-r px-1 py-2 items-center">
          {{ fee.eur | appPercentage | async }}
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Info block -->
  <div class="mt-4">
    <div class="justify-between md:flex">
      <div class="mb-4 flex md:md-0">
        <svg-icon class="mr-2" src="/assets/icons/icon-info.svg"></svg-icon>
        {{ 'otc-desk.fees.info.question' | translate }}
      </div>
      <app-action-button [size]="'xs'" [facet]="'link'" (click)="toggleInfo()">
        <svg-icon
          [src]="'/assets/icons/icon-chevron-down.svg'"
          [ngClass]="{
            'rotate-180': infoExpanded
          }"
        />
        {{ (infoExpanded ? 'otc-desk.fees.info.toggleLess' : 'otc-desk.fees.info.toggleMore') | translate }}
      </app-action-button>
    </div>

    <p *ngIf="infoExpanded" class="paragraph mt-2 text-cm-grey-800 dark:text-cm-grey-300">
      {{ 'otc-desk.fees.info.answer' | translate }}
    </p>
  </div>
</div>
